import { render, staticRenderFns } from "./TipoDocumento.vue?vue&type=template&id=59950438&"
import script from "./TipoDocumento.vue?vue&type=script&lang=js&"
export * from "./TipoDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports